import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  CardActionArea,
  Container,
  Grid,
} from "@mui/material";
import moment from "moment-timezone";
import { useState, useEffect } from "react";

const SHOW_RESOURCES = 3;

const getInitials = (name, separator = " ") => {
  return name
    .split(separator)
    .map((part) => part[0]?.toUpperCase() || "")
    .join("");
};

const truncateContent = (content, maxLength) => {
  const text = content.replace(/<[^>]+>/g, ""); // Strip HTML tags
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

const MoreResources = ({ filterId = [] }) => {
  const [resources, setResources] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    if (!hasFetched) {
      const fetchResources = async () => {
        try {
          const response = await fetch("/api/getBlogPosts");
          const data = await response.json();
          const filteredResources = data
            .filter((item) => !filterId.includes(item.id))
            .sort(() => 0.5 - Math.random())
            .slice(0, SHOW_RESOURCES);
          setResources(filteredResources);
        } catch (error) {
          console.error("Failed to fetch resources:", error);
        }
      };

      fetchResources();
      setHasFetched(true); // Ensure fetch only happens once
    }
  }, [filterId, hasFetched]); // `filterId` ensures the fetch updates if `filterId` changes

  return (
    <Container sx={{ pb: 2 }}>
      <Typography variant="h4" gutterBottom>
        Read Next
      </Typography>
      <Grid container spacing={2} sx={{ py: 2 }}>
        {resources.map((resource, idx) => (
          <Grid item xs={12} sm={6} md={4} key={`more_resources_card_${idx}`}>
            <Card>
              <CardActionArea href={"/topic/" + resource.id}>
                {resource.images?.length > 0 ? (
                  <CardMedia
                    image={resource.images[0].url}
                    sx={{ height: 150, objectFit: "cover" }}
                  />
                ) : (
                  <CardMedia
                    component="img"
                    sx={{ height: 150, objectFit: "contain" }}
                    image="/KCC-Logo.webp"
                  />
                )}
                <CardContent sx={{ py: 1 }}>
                  <Typography
                    variant="body1"
                    noWrap
                    sx={{
                      width: "100%",
                      maxWidth: "100%",
                    }}
                  >
                    {resource.title}
                  </Typography>
                  <Typography variant="caption">
                    {resource.author.displayName ||
                      getInitials(resource.author.name)}
                  </Typography>
                  <Typography variant="caption">
                    {console.log(JSON.stringify(resource))}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    component="div"
                  >
                    {moment(resource.published).fromNow()}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default MoreResources;
